define('OutSystems/ReactWidgets/Popup',["require", "exports", "tslib", "OutSystems/ReactView/Portal", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Portal_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Popup = void 0;
    var REACT_CONTAINER_ID = "reactContainer";
    var Popup = (function (_super) {
        tslib_1.__extends(Popup, _super);
        function Popup(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.updateMainContainerAriaHiddenAttr();
            _this.focusFirstFocusableElement = _this.focusFirstFocusableElement.bind(_this);
            return _this;
        }
        Popup_1 = Popup;
        Popup.prototype.componentDidMount = function () {
            this.focusFirstFocusableElement();
        };
        Popup.prototype.componentWillUnmount = function () {
            this.disableScroll(false);
            this.updateMainContainerAriaHiddenAttr();
        };
        Popup.prototype.UNSAFE_componentWillMount = function () {
            this.disableScroll(this.props.showPopup);
        };
        Popup.prototype.UNSAFE_componentWillUpdate = function (nextProps) {
            this.disableScroll(nextProps.showPopup);
        };
        Popup.prototype.componentDidUpdate = function () {
            this.updateMainContainerAriaHiddenAttr();
        };
        Popup.prototype.disableScroll = function (disable) {
            if (disable) {
                document.documentElement.classList.add(Popup_1.DisableScrollClass);
            }
            else {
                document.documentElement.classList.remove(Popup_1.DisableScrollClass);
            }
        };
        Popup.prototype.updateMainContainerAriaHiddenAttr = function () {
            if (this.props.showPopup) {
                document.getElementById(REACT_CONTAINER_ID).setAttribute("aria-hidden", "true");
            }
            else {
                document.getElementById(REACT_CONTAINER_ID).removeAttribute("aria-hidden");
            }
        };
        Popup.prototype.focusFirstFocusableElement = function () {
            if (this.props.showPopup) {
                var htmlNode = this.getHTMLNode();
                if (htmlNode) {
                    var element = htmlNode.querySelector("input, button, textarea, select, a");
                    if (element) {
                        element.focus();
                    }
                }
            }
        };
        Popup.prototype.render = function () {
            if (this.props.showPopup) {
                var popupDialogDivAttributes = {
                    "data-popup": "",
                    className: "popup-dialog " + this.props.style,
                    role: "dialog",
                    "aria-modal": true,
                };
                this.fillWithBuiltinProperties(popupDialogDivAttributes);
                return (React.createElement(Portal_1.Portal, null,
                    React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, onTouchMove: function (e) { return e.stopPropagation(); }, className: "popup-backdrop", "data-popup-backdrop": "" },
                        React.createElement("div", tslib_1.__assign({}, popupDialogDivAttributes),
                            React.createElement("div", { className: "popup-content" }, this.props.children)))));
            }
            else {
                return null;
            }
        };
        var Popup_1;
        Popup.DisableScrollClass = "popup-disable-scroll";
        Popup = Popup_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Popup);
        return Popup;
    }(Widget_1.Widget));
    exports.Popup = Popup;
});
//# sourceMappingURL=Popup.js.map;
